// extracted by mini-css-extract-plugin
module.exports = {"banner-content":"style_banner-content__mKYm4","left":"style_left__2jzP_","right":"style_right__2XBgo"};